import React, { FC, useState, useMemo } from 'react';
import { usePermissions } from '@erecruit/modules';
import { Intl } from '@erecruit/core';
import { AppPermissions, ShiftStatuses } from '@erecruit/types';
import { Dropdown, Icon, DropdownMenu } from '@erecruit/ui-kit';
import CancelShiftModal from './CancelShiftModal';
import { ColumnActionsProps, DropdownMenuItemWithPermission } from './types';

const { FormattedMessage } = Intl;

const ColumnActions: FC<ColumnActionsProps> = props => {
  const { filterState, shiftSearch } = props;
  const [closeModalVisible, setCloseModalVisible] = useState(false);
  const menuItems: DropdownMenuItemWithPermission[] = [];
  const cancelShiftMenuItem = {
    text: <FormattedMessage id={messageIds.vms.shiftSearch.actions.cancel} />,
    onClick: () => setCloseModalVisible(true),
    permission: AppPermissions.CancelShift,
  };
  const canCancelShift =
    shiftSearch.candidate === null &&
    shiftSearch.shiftStatus.id !== Number(ShiftStatuses.Cancelled);
  if (canCancelShift) menuItems.push(cancelShiftMenuItem);

  const { filterByPermissions } = usePermissions();
  const authorizedMenuItems = useMemo(() => filterByPermissions(menuItems), [
    filterByPermissions,
    menuItems,
  ]);

  return (
    <>
      {closeModalVisible && (
        <CancelShiftModal
          filterState={filterState}
          shiftSearch={shiftSearch}
          closeModalVisible={closeModalVisible}
          setCloseModalVisible={setCloseModalVisible}
        />
      )}
      {authorizedMenuItems.length > 0 && (
        <Dropdown
          overlay={
            <DropdownMenu style={{ width: 220 }} items={authorizedMenuItems} />
          }
        >
          <Icon type="more" />
        </Dropdown>
      )}
    </>
  );
};

export default ColumnActions;
